import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { Exact } from "@Helpers/types/exact";
import type { ProjectCurrency } from "@ServerTypes/currency/currency.schema";

/**
 * Members carry an explicit `| undefined`: `Exact<CurrencyState, T>` maps over `CurrencyState`'s own
 * keys, and an indexed read of an optional key is `X | undefined`, so the mapped payload type holds
 * a genuinely-undefined value for every key. Under `exactOptionalPropertyTypes` a key-must-be-ABSENT
 * optional would refuse it, which is what broke the `setCurrencyDetails` wrapper below.
 */
export interface CurrencyState {
  /** The project's stored `currency` embed, as `/currency/getDefaultCurrencyDetailForProjectLevel` sends it. */
  currency?: ProjectCurrency | undefined;
  isDisable?: boolean | undefined;
}

const currencySlice = createSlice({
  name: "currencyDetails",
  initialState: {} as CurrencyState,
  reducers: {
    setCurrencyDetails: (_state: CurrencyState, action: PayloadAction<CurrencyState>) => ({
      ...action.payload,
    }),
  },
});

const { setCurrencyDetails: _setCurrencyDetailsRaw } = currencySlice.actions;

/**
 * Object-payload action creator wrapped with `Exact<>` so excess properties
 * are caught even when the payload is passed through a variable.
 */
export const setCurrencyDetails = <T extends Exact<CurrencyState, T>>(payload: T) => _setCurrencyDetailsRaw(payload);

export const currencyDetails = currencySlice.reducer;

export default currencySlice.reducer;
